




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ordersService from '@/modules/orders/ordersService';
import notificationService from '@/services/notificationService';

import { DxDataGrid, DxEditing, DxColumn, DxRequiredRule, DxStateStoring, DxColumnChooser, DxColumnFixing, DxFilterRow, DxLookup } from 'devextreme-vue/data-grid';

import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { OrderStatus, OrderType } from '@/modules/orders/enums';
import CreateOrderPopup from '@/modules/orders/components/CreateOrderPopup.vue';
import { DataSourceLoadOptionsBase, OrdersClient, OrdersLookupQuery } from '@/data/web-api-client';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxLookup,
    Datagrid,
    CreateOrderPopup,
  },
})
export default class OrdersTable extends Vue {
  declare currency: any;

  @Prop({ required: false })
  public supplierId: string | undefined;

  @Prop({ required: false })
  public projectId: string | undefined;

  @Prop({ required: false, default: true })
  public standalone!: boolean;

  @Prop({ required: false, default: true })
  public expanded!: boolean;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  materialAmount = 0;
  subcontactorAmount = 0;

  public showFilter: boolean = false;
  public loading: boolean = false;
  public creating: boolean = false;
  public show: boolean = false;

  private ordersClient = new OrdersClient(undefined, this.$axios);

  get datasource(): DataSource {
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          loadOptions.requireTotalCount = true;

          const query = new OrdersLookupQuery({
            projectId: this.projectId ?? '',
            supplierId: this.supplierId ?? '',
            options: DataSourceLoadOptionsBase.fromJS(loadOptions),
          });

          const result = await this.ordersClient.lookup(query);

          this.materialAmount = result.materialAmount ?? 0;
          this.subcontactorAmount = result.subcontractorAmount ?? 0;

          return {
            data: result.data,
            totalCount: result.totalCount,
          };
        },
        byKey: async (val: any) => {
          return (await ordersService.getSingle(val)).data;
        },
        remove: async (key: string) => {
          try {
            await ordersService.delete(key).then(() => {
              notificationService.saved();
              self.refreshTable();
            });
          } catch (err) {
            notificationService.failedToSave();
          }
        },
      }),
      paginate: true,
    });
  }

  public toggleShow() {
    this.show = !this.show;
  }

  public add() {
    (this.$refs.CreateOrderPopup as CreateOrderPopup).open();
  }

  public openDetails(e: any) {
    if (e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({ path: `/orders/${e.row.data.id}` });
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  deleteRow(e: any) {
    const self = this;

    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await ordersService.delete((e.data as IOrderListItemDto).id).then(() => {
          notificationService.saved();
          self.refreshTable();
          resolve(false);
        });
      } catch (err) {
        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  refreshTable() {
    this.gridInstance.refresh();
  }

  get gridInstance() {
    return ((this.$refs.grid as Vue).$refs.ordersTable as any).instance;
  }

  get toolbarOptions() {
    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: this.add,
          disabled: this.disabled,
        },
      },
    ];
  }

  get columns() {
    return [
      {
        dataField: 'documentNumber',
        caption: this.$t('objects.invoices.DocumentNumber'),
      },
      {
        dataField: 'projectName',
        caption: 'Projectnaam',
      },
      {
        dataField: 'supplierName',
        caption: 'Leverancier',
      },
      {
        dataField: 'date',
        caption: 'Datum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'invoiceReceived',
        caption: 'Factuur ontvangen',
        dataType: 'boolean',
      },
      {
        dataField: 'goodsReceived',
        caption: 'Ontvangen',
        dataType: 'boolean',
      },
      {
        dataField: 'type',
        caption: 'Soort',
        lookup: {
          dataSource: [
            { value: OrderType.MaterialsOrder, text: 'Materiaal' },
            { value: OrderType.SubcontractorSettlement, text: 'Afrekening' },
            { value: OrderType.Other, text: 'Andere' },
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: {
          dataSource: [
            { value: OrderStatus.Draft, text: 'Klad' },
            { value: OrderStatus.Open, text: 'Open' },
            { value: OrderStatus.Send, text: 'Verstuurd' },
            { value: OrderStatus.Completed, text: 'Afgerond' },
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        dataField: 'totalExcl',
        caption: 'Totaal excl.',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Project openen',
            icon: 'fas fa-briefcase',
            visible(e: any) {
              return !e.row.isEditing && e.row.data.projectId;
            },
            onClick: (e: any) => {
              this.$router.push({ path: `/projects/${e.row.data.projectId}` });
            },
          },
          'delete',
        ],
      },
    ];
  }
}
